<!-- 小程序-云视频 -->
<template>
  <div class="AppletCloudVideo" id="apply">
    <p>汕头移动</p>
    
    <video class="video-js vjs-default-skin" id="drowningDetectionVideo" controls preload="none" width="640" height="264" autoplay playsinline=true webkitPlaysinline=true
        data-setup="{}">
      <!-- <source src="https://cmccshantou-video.geekuiot.com/hls/44000000000105010103000000091214.m3u8" type='application/x-mpegURL'/> -->
      <!-- <source :src="src" type='application/x-mpegURL' /> -->
      <track kind="captions" src="demo.captions.vtt" srclang="en" label="English"></track>
      <track kind="subtitles" src="demo.captions.vtt" srclang="en" label="English"></track>
      <p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>
    </video>
  </div>
</template>

<script>
  import { AppletApi } from '../../../../static/js/phone/phoneApi.js'
  import { vshowLoading, vhideLoading, vshowSuccess, vshowToast } from '../../../../static/js/phone/utility.js'
  import { setDeviceIcon } from '../../../../static/js/utility/utility.js'
  let Hls = require('hls.js')

  import videojs from 'video.js'
  import 'video.js/dist/video-js.css'

  import Vue from 'vue'
  import { NavBar } from 'vant'
  Vue.use(NavBar)

  let vm

  export default {
    name: 'AppletCloudVideo',
    components: {
    },
    data () {
      return {
        input: '',
        myVideo: '',
        src: 'http://ivi.bupt.edu.cn/hls/cctv1hd.m3u8' // CCTV1
        // src: 'http://183.235.209.46:8081/hls/44000000000105010103000000091214.m3u8' // 汕头移动
        // src: 'https://cmccshantou-video.geekuiot.com/hls/44000000000105010103000000104521.m3u8' // 汕头移动
      }
    },
    created () {
      vm = this
    },
    mounted () {
      // console.log('tag', vm.$route)
      vm.$nextTick(()=>{
        // vm.VIDEOCLOUDLoad(vm.src) // 汕头移动
        // videojs.options.flash.swf = require('../../../../static/js/phone/video-js.swf');
        var videoPlayer = videojs("drowningDetectionVideo", {
          "controls" : false,
          "autoplay" : true,
          "preload" : "none",
        //  "fluid" : true,
          "language" : "zh-cn",
          "LoadingSpinner" : true,
          "flash" : {
            "swf" : "../../../../static/js/phone/video-js.swf"
          },
          "techOrder" : ["html5", "flash"]
        }, function onPlayerReady() {
          this.on("play", function() {
          });
        });
        videoPlayer.src({
          "src": vm.src,
          "type": "application/x-mpegURL",
        });
      })
    },
    methods: {
      getVideo() {
        vm.myVideo = videojs("myVideo", {
          src: vm.src,
          autoplay: true,
          bigPlayButton: true,
          textTrackDisplay: false,
          posterImage: false,
          errorDisplay: false,
          hls: {
            withCredentials: true
          }
        })

        vm.myVideo.load()
        vm.myVideo.play()

        console.log('tag', vm.myVideo)
      },
      HlsVIDEOCLOUDLoad(source) {
        let ref_video = vm.$refs.video
        if (Hls.isSupported()) {
            vm.hls = new Hls()
            vm.hls.loadSource(source)
            vm.hls.attachMedia(ref_video)

            vm.hls.on(Hls.Events.MANIFEST_PARSED, () => {
                console.log("加载成功")
                ref_video.play()
            });
            vm.hls.on(Hls.Events.ERROR, (event, data) => {
                // 监听出错事件
                console.log("加载失败")
                console.log(event, data)
            });
        } else if (ref_video.canPlayType('application/vnd.apple.mpegurl')) {
            ref_video.src = source
            ref_video.addEventListener('loadedmetadata',function() {
                ref_video.play()
            });
        }
      },
    }
  }
</script>

<style lang="scss">
  .AppletCloudVideo {
  }

  .focusState {
    position: absolute;
  }

</style>


// WEBPACK FOOTER //
// src/components/PhonePage/Applet/CloudVideo.vue